
export const BASE_URL = "https://api.odaz.app";